<div class="editor-host" cdkOverlayOrigin #trigger="cdkOverlayOrigin"></div>

<ng-template
    (attach)="onOverlayAttach(overlay)"
    #overlay="cdkConnectedOverlay"
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="open()"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayGrowAfterOpen]="true"
    [cdkConnectedOverlayViewportMargin]="8"
    [cdkConnectedOverlayHasBackdrop]="false"
>
    <div class="panel-container ag-custom-component-popup">
        <input
            #dateInput
            libDateInputMask
            type="text"
            class="input-search"
            [value]="keyboardDate"
            (keyboardDateChange)="onKeyboardDateChange($event)"
            (keyboardDateBlur)="onKeyboardDateBlur($event)"
            (keydown.enter)="onEnterPressed($event)"
            (keydown.tab)="onTabPressed($event)"
            tabindex="0"
        />
        <div #container tabindex="0">
            <lib-datepicker
                #datepicker
                [(selectedDate)]="selectedDateTime"
                [timeEnabled]="true"
                [format]="dateFormat"
                (saveDate)="onDatepickerChanged()"
                (resetDate)="onDatepickerChanged()"
            >
            </lib-datepicker>
        </div>
    </div>
</ng-template>
